import { EmpresaService } from './src/services/empresas.services';

export type { Empresa, UsuarioEmpresa, EmpresaProducto } from './src/services/suite.interfaces';

export const empresaService = new EmpresaService();

export default empresaService;
